@if (isVisible()) {
    <p-message
        [dt]="pMessageScopedToken"
        severity="info"
        class="block w-full max-w-full text-center bp908:mx-auto bp908:w-64"
        styleClass="overflow-hidden !rounded-none outline-offset-[-1px] bp908:!rounded-2xl">
        <ng-template #container>
            <div class="relative flex min-h-[30px] w-full">
                <!-- On desktop the × sits inside the 256px pill, so shift the label left to make room for it -->
                <button
                    type="button"
                    class="flex w-full cursor-pointer items-center justify-center whitespace-nowrap rounded-none bg-[var(--p-blue-100)] px-[10.5px] py-[3px] font-inter text-[15px] font-medium leading-normal text-[var(--p-blue-600)] shadow-[0_4px_4px_rgba(2,5,10,0.04)] transition-opacity hover:opacity-90 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-[-2px] focus-visible:outline-current bp908:rounded-[15px] dark:bg-[var(--p-blue-500)] dark:text-[var(--p-blue-50)]"
                    [class]="showDismissButton() ? 'bp908:pl-2 bp908:pr-7' : ''"
                    (click)="onClickGroupMeetings()">
                    @if (isHost()) {
                        🌼 You’re a Group Sessions Host!
                    } @else {
                        🌼 New: Try Group Sessions!
                    }
                </button>

                @if (showDismissButton()) {
                    <button
                        type="button"
                        class="absolute right-2 top-1/2 flex size-7 -translate-y-1/2 cursor-pointer items-center justify-center rounded-full border-0 bg-transparent text-xl leading-none transition-opacity hover:opacity-70 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-[-2px] focus-visible:outline-current bp908:right-1 bp908:size-6"
                        aria-label="Dismiss Group Sessions promotion"
                        (click)="onDismiss()">
                        &times;
                    </button>
                }
            </div>
        </ng-template>
    </p-message>
}
